<template>
  <div id="container-bow-thruster-2-pitch">
    <svg id="bow-thruster-1-pitch-svg" width="100" height="80" viewBox="0 0 100 100">
      <defs>
        <g id="bow-thruster-2-pitch-mark">
          <line
            id="bow-thruster-2-pitch-mark-line"
            x1="0"
            y1="-30"
            x2="0"
            y2="30"
            :stroke="sdfColor.MandarinOrange"
            stroke-width="5"
          />
          <animateTransform
            id="animate-bow-thruster-2-pitch-mark-line"
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            :from="from"
            :to="to"
            dur="2s"
            fill="freeze"
          />
        </g>
        <g id="bow-thruster-2-pitch-circle">
          <svg width="40" height="40" viewBox="0 0 71 52" fill="none">
            <path
              d="M37.3205 0C52.7949 0 71 0 71 0V52C71 52 56.4359 52 37.3205 52C18.2051 52 0 37.6552 0 26C0 14.3448 21.8462 0 37.3205 0Z"
              fill="#C4C4C4"
            />
          </svg>
          <use
            xlink:href="#bow-thruster-2-pitch-mark"
            transform="translate(30, 20)"
          />
          <circle
            cx="30"
            cy="20"
            r="5"
            :fill="sdfColor.MandarinOrange"
            :stroke="sdfColor.MandarinOrange"
            stroke-width="2"
          />
        </g>
      </defs>

      <use xlink:href="#bow-thruster-2-pitch-circle" transform="translate(0, 15)" />
      <text
        x="25"
        y="90"
        class="sdf-text-20-400-white"
        text-anchor="middle"
        :fill="sdfColor.White"
      >
        {{ valueDisplay || "---" }}
      </text>
    </svg>
  </div>
</template>

<script>
import { ColorMixin, MappingTableMixin } from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [ColorMixin, MappingTableMixin],
  data() {
    return {
      from: 0,
      to: 0,
      valueRange: 30
    };
  },
  props: {
    value: {
      type: Number,
      default: 100
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.updateValue(oldValue, newValue);
    }
  },
  computed: {
    valueDisplay() {
      if (this.value !== null) {
        let val = this.value === 0 ? "0.0" : this.value.toFixed(1);
        return `${val}°`;
      }
    }
  },
  methods: {
    updateValue(from, to) {
      this.showAnimate = true;
      let markEl = document.getElementById(`animate-bow-thruster-2-pitch-mark-line`);
      this.from = from;
      this.to = to;
      markEl.beginElement();
    }
  },
  mounted() {
    this.updateValue(this.value, this.value);
  }
};
</script>

<style lang="scss"></style>
